import React, { lazy, Suspense, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import Header from "./components/Header";
import Body from "./components/Body";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Error from "./components/Error";
import RestaurantMenu from "./components/RestaurantMenu";
import UserContext from "./utils/UserContext";
import { Provider } from "react-redux";
import appStore from "./utils/appStore";
import Cart from "./components/Cart";
import About from "./components/About";

// const About = lazy(()=>import("./components/About"))

const AppLayout = () => {

    const[userName, setuserName] = useState();

    useEffect(()=>{
        const data = {
            name: "Aashish Rana"
        };
        setuserName(data.name);
    }, [])

        return (
            <Provider store={appStore}>
            <UserContext.Provider value={{loggedInUser: userName, setuserName}}>
            <div className="app">
                <Header />
                <Outlet/>
            </div>
            </UserContext.Provider>
            </Provider>
        )
    }
const appRouter = createBrowserRouter([
    {
        path: "/",
        children:[
        {
        path: "/",
        element: <Body/>
        },
        // {
        // path: "/about",
        // element: (<Suspense fallback={<h1>Loading..</h1>}>
        //     <About/>
        //     </Suspense>)
        // },
        {
        path: "/about",
        element: <About/>
        },
        {
        path: "/restaurants/:resId", 
        element: <RestaurantMenu/>
        },
        {
        path: "/cart", 
        element: <Cart/>
        },
        ],
        element: <AppLayout/>,
        errorElement: <Error/>
    },
])

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(<RouterProvider router={appRouter} />)